<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbItems">
    <v-container class="mt-0 pt-0">
      <v-row>
        <v-col md="12">
          <v-img src="@/static/images/organization/cover.jpg" height="200">
            <v-row class="fill-height" align="end" justify="center">
              <v-col md="12">
                <div class="text-right">
                  <v-chip
                    label
                    color="blue"
                    text-color="white"
                    class="font-weight-bold"
                  >
                    <v-icon left v-text="$getIcon('mdiLabel')" color="white">
                    </v-icon>
                    NEGOTIATING
                  </v-chip>
                </div>
              </v-col>
              <v-col md="12">
                <v-avatar class="d-inline-block mx-3 mb-2" size="120" tile>
                  <v-img
                    v-if="clientDetail.logo"
                    :src="clientDetail.logo"
                    contain
                  ></v-img>
                  <v-img
                    v-else
                    src="@/static/images/organization/default-logo.jpg"
                    contain
                  ></v-img>
                </v-avatar>
                <div class="mx-1 white--text d-inline-block">
                  <h1 class="client-heading">
                    {{ clientDetail.name.toUpperCase() }}
                  </h1>
                  <h2 class="client-heading">
                    {{
                      clientDetail.abbreviation
                        ? `(${clientDetail.abbreviation})`
                        : ""
                    }}
                  </h2>
                  <div class="white--text caption">
                    Client Value:
                    <v-chip
                      small
                      outlined
                      :color="`${clientValueColor[clientDetail.client_value]}`"
                    >
                      {{ clientDetail.client_value || "N/A" }}
                    </v-chip>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-img>
          <v-card class="elevation-5 mt-1">
            <v-tabs
              v-model="active"
              class="mx-0"
              color="grey darken-4"
              slider-color="grey"
            >
              <v-tab
                v-for="(tab, index) in tabOptions"
                :key="index + `tabHeadings`"
                class="text-capitalize"
              >
                <v-icon class="mr-2 subheading" v-text="tab.icon"></v-icon>
                {{ tab.name }}
              </v-tab>
              <v-tab-item
                v-for="(tab, index) in tabOptions"
                :key="index + `tabItems`"
              >
                <component
                  :is="tab.component"
                  :client-detail.sync="clientDetail"
                  @clientFormResponse="formSuccess($event)"
                  view-only
                ></component>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </vue-page-wrapper>
</template>

<script>
import ClientOverview from "@/components/crm/client/client_detail/ClientOverview";
import ClientContactPersons from "@/components/crm/client/client_detail/ClientContactPersons";
import ClientBranch from "@/components/crm/client/client_detail/ClientBranch";
import ClientCommunicationLogs from "@/components/crm/client/client_detail/ClientCommunicationLogs";

export default {
  components: {
    ClientOverview,
    ClientContactPersons,
    ClientBranch,
    ClientCommunicationLogs
  },
  data() {
    return {
      htmlTitle: "Clients | CRM",
      breadCrumbItems: [
        { text: "Clients", disabled: false, to: { name: "clients" } },
        {
          text: `${this.$route.params.clientSlug}`,
          disabled: true
        }
      ],
      active: 3,
      clientDetail: {},
      tabOptions: [
        {
          name: "Overview",
          component: "ClientOverview",
          icon: this.$getIcon("mdiEarth")
        },
        {
          name: "Contact Persons",
          component: "ClientContactPersons",
          icon: this.$getIcon("mdiAccountCircle")
        },
        {
          name: "Branches",
          component: "ClientBranch",
          icon: this.$getIcon("mdiNearMe")
        },
        {
          name: "Activity Logs",
          component: "ClientCommunicationLogs",
          icon: this.$getIcon("mdiHistory")
        }
      ],
      clientValueColor: {
        Low: "red",
        Mid: "amber",
        High: "green"
      }
    };
  },
  watch: {
    //for re-rendering page if someone searches from client detail page
    "$route.params.clientSlug": {
      handler(val) {
        if (val) {
          window.location.reload();
        }
      }
    }
  },
  created() {
    this.fetchClientDetail();
  },
  methods: {
    formSuccess() {
      this.fetchClientDetail();
    },
    fetchClientDetail() {
      const endPoint = `/api/v1/crm/clients/${this.$route.params.clientSlug}`;
      this.$axios.$get(endPoint).then(response => {
        this.clientDetail = response;
      });
    }
  }
};
</script>
